import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { getPrimaryContact } from '@wayste/utils';
import { UserIcon } from '@heroicons/react/20/solid';
import { CustomFormContext } from '../../formWrapper/SourSearchWrapper';
import { ErrorBoundary } from './helper/ErrorBoundary';
import { ResultWrapper } from './helper/resultWrapper';
export const CustomerResult = ({ customer, hit, }) => {
    const { companyName, id, contacts } = customer;
    const { onNavigate, onResetValues } = useContext(CustomFormContext);
    // useEffect(() => {
    //   console.log('PAYLOAD customer', customer);
    // }, []);
    const handleRedirect = () => {
        onNavigate(customer, id, 'customers');
        onResetValues('search');
    };
    return (_jsx(ErrorBoundary, { children: _jsxs(ResultWrapper, { onRedirect: handleRedirect, children: [_jsx(UserIcon, { className: "size-4" }), _jsx("div", { className: "border-l-2 border-gray-300 pl-2", children: contacts.length > 0 ? (_jsxs(_Fragment, { children: [getPrimaryContact(customer)
                                ? getPrimaryContact(customer)?.firstName
                                : contacts[0].firstName, ' ', getPrimaryContact(customer)
                                ? getPrimaryContact(customer)?.lastName
                                : contacts[0].lastName] })) : ('Unknown') }), companyName ? _jsx("div", { className: "border-l-2 border-gray-300 pl-2", children: companyName }) : _jsx(_Fragment, {}), _jsx("div", { className: "border-l-2 border-gray-300 pl-2", children: getPrimaryContact(customer)?.email })] }) }));
};
//# sourceMappingURL=CustomerResult.js.map